// Shared timing constants for the Login flicker-and-reveal animation.
// Imported by both `Login.js` and `Login.test.js` so the test can advance
// fake timers by the exact durations the component schedules.
//
// ARCH-037: prior tests hardcoded `jest.advanceTimersByTime(200)` x15 + 600 +
// 1200 + 800; any change to the durations in Login.js silently broke the test.

export const FLICKER_INTERVAL_MS = 150;
export const FLICKER_TO_FINAL_DELAY_MS = 100;
export const FINAL_TO_BRAND_DELAY_MS = 600;
export const BRAND_TO_READY_DELAY_MS = 1200;
export const READY_TO_FORM_DELAY_MS = 800;
